import { getAxiosInstance } from "../../../../../api";

export const createProductDetails = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/orders/create`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateProductDetails = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/orders/update`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const viewProviders = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/admin/service-providers/edit?service_provider_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};